import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { LANG_TRANS } from '../constants';
import { PrimaryLang } from '../type/translation.enum';
import type { OriginalOptions } from '../type/translation.type';

export const OriginalOptionsService = Symbol('OriginalOptionsService');

export interface OriginalOptionsService {
   initialize: (patentLangList: string[]) => OriginalOptions;
}

const EXCLUDE_LANG: string[] = [PrimaryLang.CN, PrimaryLang.EN, PrimaryLang.JP];

@injectable()
export class OriginalOptionsServiceImpl implements OriginalOptionsService {
    private _getLabel(lang: string) {
        return LANG_TRANS[lang] || '';
    }

    public initialize(patentLangList: string[]) {
        const originalLangList = _.uniq(patentLangList);

        return originalLangList
            .filter(lang => !EXCLUDE_LANG.includes(lang))
            .map(lang => ({ lang, label: this._getLabel(lang) }))
            .filter(item => !!item.label);
    }
}
